import { render, staticRenderFns } from "./PosList.vue?vue&type=template&id=23b6cf42&"
import script from "./PosList.vue?vue&type=script&lang=js&"
export * from "./PosList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports